<div class="message-name" *ngIf="msg.userId === otherUser?.id">{{otherUser.firstName}}
</div>
<div class="message-text" [innerHTML]="formattedMessage"></div>
<div class="message-utility-row"  [ngClass]="{'right': justifyRight}" >
    <div class="message-timestamp">
        {{translateMessageTimestamp(msg.timestamp)}}
    </div>
</div>
<div class="og-preview" [ngClass]="{'right': justifyRight}" *ngIf="msg.urlMetadata">
    <a [href]="msg.sharedUrl" target="_blank">
      <div class="preview-image" *ngIf="msg.urlMetadata.image">
        <img [src]="msg.urlMetadata.image" />
      </div>
      <div class="preview-content">
        <div class="title">{{ msg.urlMetadata.title }}</div>
        <div class="description">{{ msg.urlMetadata.description }}</div>
      </div>
    </a>
  </div>